import http from "../../http";
import { wrapErrorHandler } from "../../utils/wrap_error_handler";
import DecoinInterface from "./decoins_interface";
import { DecoinLimit } from "../../../../domain/entities/decoins";
import { Order } from "../../../../domain/entities/order";

class DecoinRepository implements DecoinInterface {
  async dailyDecoinLimit(): Promise<DecoinLimit> {
    return wrapErrorHandler<DecoinLimit>(async () => {
      const response = await http.get(`/api/decola/decoinsMaxDaily`);
      return response.data;
    });
  }

  async decoinDailyLimitMessageAccepted(): Promise<void> {
    return wrapErrorHandler<void>(async () => {
      return await http.post(`/api/decola/decoins/accept`);
    });
  }

  async getPdfExtractDecoins(order: Order): Promise<string> {
    return await wrapErrorHandler<string>(async () => {
      const response = await http.get(
        `/api/decola/list/statement/user/report`,
        {
          params: {
            firstDate: order.firstDate,
            lastDate: order.lastDate,
            type: order.type,
            typeCode: order.typeCode
          }
        }
      );
      return response.data;
    });
  }

  async getExcelExtractDecoins(order: Order): Promise<string> {
    return await wrapErrorHandler<string>(async () => {
      const response = await http.get(
        `/api/decola/list/statement/user/report/excel`,
        {
          params: {
            firstDate: order.firstDate,
            lastDate: order.lastDate,
            type: order.type,
            typeCode: order.typeCode
          }
        }
      );
      return response.data;
    });
  }
}

export default new DecoinRepository() as DecoinInterface;
